<template>
  <div class="search-wrapper">
    <i class="fas fa-search"></i>

    <input
      :value="value"
      type="text"
      placeholder="Pesquisar município..."
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: 'RankingSearch',

  props: {
    value: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.search-wrapper {
  position: relative;
  max-width: 420px;
  margin-bottom: 20px;
}

.search-wrapper i {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  color: #9ca3af;
}

input {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 12px 12px 40px;
  outline: none;
  font-size: 14px;
}

input:focus {
  border-color: #3b82f6;
}
</style>
